/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Preview_CleanInputs */

const cs_import_preview_clean = /** @type {(inputs: Import_Preview_CleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled neobsahuje žádné problémy.`)
};

const en_import_preview_clean = /** @type {(inputs: Import_Preview_CleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No issues in the dry-run sample.`)
};

/**
* | output |
* | --- |
* | "No issues in the dry-run sample." |
*
* @param {Import_Preview_CleanInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_preview_clean = /** @type {((inputs?: Import_Preview_CleanInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Preview_CleanInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_preview_clean(inputs)
	return cs_import_preview_clean(inputs)
});